export default function HardwareBestellung () {
  return (
    <iframe
      height="100%"
      src="https://intranet-backend.procuratio.com/hardware_bestellung.html"
      width="100%"
    />
  );
}
